function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

(async () => {
  const { updateURLParams: s, historyPush: n } = await import(
    window.theme.modules.utils
  );
  var e = await import(window.theme.modules.baseComponent);
  customElements.define(
    "collection-sort",
    class extends e.default {
      constructor(...args) {
        super(...args);

        _defineProperty(this, "elements", {
          select: "select",
        });
      }

      render() {
        this.$select.addEventListener(
          "change",
          this._onChangeHandler.bind(this)
        );
      }

      _onChangeHandler() {
        var { queryURL: e, currentURL: t } = s(
          {
            sort_by: this.$select.value,
          },
          this.getAttribute("section-id")
        );
        this.trigger("filterUpadting"), this._fetchChanges(e), n(t);
      }

      _fetchChanges(e) {
        fetch(e)
          .then((e) => e.text())
          .then((e) => {
            this.forwardEvent("sortChange", {
              html: e,
            });
          });
      }

      _updateURL(e) {
        window.history.pushState(
          {
            searchParams: e,
          },
          "",
          `${window.location.pathname}${e && "?".concat(e)}`
        );
      }
    }
  );
})();
